import { Modal } from '@shared/ui/modal';
import styles from './DeleteParticipantModal.module.scss';

interface DeleteParticipantModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  participantName: string;
}

export const DeleteParticipantModal = ({
  isOpen,
  onClose,
  onConfirm,
  participantName,
}: DeleteParticipantModalProps) => {
  const message = `Удалить участника "${participantName}"?`;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Подтвердите действие"
      width={528}
      cancelButton={{ text: 'Отмена', onClick: onClose }}
      applyButton={{ text: 'Подтвердить', onClick: onConfirm }}
    >
      <div className={styles.content}>{message}</div>
    </Modal>
  );
};
